import React, { useLayoutEffect, useState } from "react";
import { Tooltip } from "antd";

interface TargetTooltipProps {
    selector: string;

    title: React.ReactNode;
}

interface TipPosition {
    top: number;
    left: number;
    width: number;
    height: number;
}

const TargetTooltip: React.FC<TargetTooltipProps> = function (props) {
    const { selector, title } = props;

    const [tip, setTip] = useState<TipPosition>();

    useLayoutEffect(() => {
        const timer = setInterval(() => {
            const el = document.querySelector(selector);

            const rect = el.getBoundingClientRect();

            setTip({
                top: rect.top,
                left: rect.left,
                width: rect.width,
                height: rect.height,
            });
        }, 1000);

        return () => {
            clearInterval(timer);
        };
    }, [selector]);

    if (!tip) {
        return null;
    }

    return (
        <Tooltip
            classNames={{ root: "ec-beginner-guide-tip-holder-tooltip-container" }}
            color="white"
            title={title}
            open
            getPopupContainer={(node) => {
                return node;
            }}
        >
            <div
                className="tip-holder-container"
                style={{
                    top: tip.top,
                    left: tip.left,
                    width: tip.width,
                    height: tip.height,
                }}
            >
                {"　"}
            </div>
        </Tooltip>
    );
};

export default React.memo(TargetTooltip);
